/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCircularStatus = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M11 1v6h1a5 5 0 1 1-5 5v-1H1v1c0 6.075 4.925 11 11 11s11-4.925 11-11S18.075 1 12 1zm2 4.071V3.055l.05.006A9 9 0 0 1 12 21l-.265-.005a9.003 9.003 0 0 1-8.64-7.684L3.055 13h2.016l.028.181A7 7 0 0 0 19 12l-.003-.24a7.003 7.003 0 0 0-5.814-6.66z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCircularStatus as CircularStatus };
